import { Outlet } from "react-router-dom";
import Palette from "../utils/Palette";
import Header from "../reusable/Header";
import Footer from "../reusable/Footer";
import { useState, useEffect } from "react";
import langId from '../utils/lang/id'

export default function HomeLayout({ }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 576)
    const [lang, setLang] = useState(langId)
    useEffect(() => {
        const handleWindowResize = () => {
            setIsMobile(window.innerWidth < 576)
        };

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    return <div>
        <Header isMobile={isMobile} lang={lang} setLang={setLang} />
        <div style={{marginTop: isMobile ? 0 : 100}}>
            <Outlet context={[isMobile, setIsMobile, lang, setLang]} />
        </div>
        <Footer isMobile={isMobile} lang={lang} setLang={setLang}/>
    </div>
}